import { Component, Fragment } from "react";
import { CommonService } from "../js_modules/CommonService";

import { SellToWebAdminInputComponent } from "../common/selltowebinput/SellToWebAdminInputComponent";
import { SellToWebAdminCheckboxComponent } from "../common/selltowebcheckbox/SellToWebAdminCheckboxComponent";
import { SellToWebAdminDropdownComponent } from "../common/selltowebdropdown/SellToWebAdminDropdownComponent";

import { TenantSiteDetailQueryComponent } from "./TenantSiteDetailQueryComponent";

export class TenantSiteDetailComponent extends Component {
    valuationMethod = [
        { key: "MMR", value: "MMR" }
    ];

    status = [
        { key: "Active", value: "Active" },
        { key: "Inactive", value: "Inactive" }
    ];

    constructor(props) {
        super(props);
        this.state = {
            isLoadingData: false,
            siteName: null,
            siteDomain: null,
            useLocations: false,
            isProduction: false,
            crmUrl: null,
            crmDeliveryEmail: null,
            crmDeliveryFormat: null,
            status: null,
            valuationMethod: null,
            deleteSite: false,
            tenantGuid: null,
            defaultZipCode: null,
            offerExpirationDays: null,
            paintTable: false,
            tenantShortName: null,
            logSiteName: null,
            useAutoCheck: false,
            usePlateToVin: false,
            customDomain1: null,
            customDomain2: null,
            canEdit: false
        };

        this.onGetClick = this.onGetClick.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
        this.onDropdownChange = this.onDropdownChange.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);

        props.onPageChanged({
            pageTitle: this.pageTitle
        });
    }

    pageTitle = "Site Detail";

    componentDidMount() {
        try {
            this.props.applicationInsights.trackPageView({ name: this.pageTitle, url: "/Tenant/Site", pageType: "Consumer/Admin", isLoggedIn: "Yes", properties: { logon: this.props.logon } });
            CommonService.clientAzureStorageLog("TenantSiteDetailComponent", "componentDidMount", null, null, null, null, this.props.applicationInsights);
            this.getTenants();
        }
        catch (error) {
            console.logError(error, "TenantSiteDetailComponent", "componentDidMount");
        }
    }

    getTenants() {
        try {
            this.setState({ isLoadingData: true });
            this.props.applicationInsights.trackTrace({ message: "TenantSiteDetailComponent/getTenants", properties: { logon: this.props.logon } });
            fetch("/TenantSite/GetTenants", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;"
                },
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    this.setState({
                        isLoadingData: false,
                        tenants: parsedResponse.result,
                        canEdit: parsedResponse.isInEditRole
                    });
                })
                .catch(notOKResponse => {
                    this.setState({
                        isLoadingData: false
                    });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/TenantSite/GetTenants", ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "TenantSiteDetailComponent", "getTenants");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "TenantSiteDetailComponent", "getTenants");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "TenantSiteDetailComponent", "getTenants");
        }
    }

    onTextChange(id, value) {
        try {
            this.setState({ [id]: value });
        }
        catch (error) {
            console.logError(error, "TenantSiteDetailComponent", "onTextChange", id);
        }
    }

    onDropdownChange(id, value) {
        try {
            this.setState({ [id]: value.key });
        }
        catch (error) {
            console.logError(error, "TenantSiteDetailComponent", "onDropdownChange", id);
        }
    }

    onCheckboxChange(id, isChecked) {
        try {
            this.setState({ [id]: isChecked });
        }
        catch (error) {
            console.logError(error, "TenantSiteDetailComponent", "onCheckboxChange");
        }
    }

    onGetClick(selectedSite) {
        try {
            this.setState({ isLoadingData: true });
            let inputData = {
                siteGuid: selectedSite.guid
            };
            this.props.applicationInsights.trackTrace({ message: "TenantSiteDetailComponent/onGetClick", properties: { ...inputData, logon: this.props.logon } });
            fetch("/TenantSite/GetSiteDetails", {
                method: "POST",
                headers: {
                    'Content-Type': "application/json; charset=utf-8;"
                },
                body: JSON.stringify(inputData),
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    parsedResponse = parsedResponse[0];
                    this.setState({
                        isLoadingData: false,
                        tenantGuid: parsedResponse.tenantGuid,
                        tenantShortName: parsedResponse.tenantShortName,
                        cardTitle: parsedResponse.tenantName + " - " + parsedResponse.siteName,
                        siteName: parsedResponse.siteName,
                        logSiteName: parsedResponse.siteName,
                        siteDomain: parsedResponse.siteDomain,
                        customDomain1: parsedResponse.customDomain1,
                        customDomain2: parsedResponse.customDomain2,
                        crmUrl: parsedResponse.crmUrl,
                        crmDeliveryEmail: parsedResponse.crmDeliveryEmail,
                        crmDeliveryFormat: parsedResponse.crmDeliveryFormat,
                        defaultZipCode: parsedResponse.defaultZip,
                        offerExpirationDays: parsedResponse.offerExpirationDays,
                        status: parsedResponse.status,
                        useLocations: parsedResponse.useLocations,
                        isProduction: parsedResponse.isProduction,
                        useAutoCheck: parsedResponse.useAutoCheck,
                        usePlateToVin: parsedResponse.usePlateToVin,
                        valuationMethod: parsedResponse.valuationMethod
                    });
                })
                .catch(notOKResponse => {
                    this.setState({
                        isLoadingData: false
                    });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/TenantSite/GetSiteDetails", ...inputData, ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "TenantSiteDetailComponent", "onGetClick");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "TenantSiteDetailComponent", "onGetClick");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "TenantSiteDetailComponent", "onGetClick");
        }
    }

    onSaveClick(selectedSite, selectedTenant) {
        try {
            this.setState({ isLoadingData: true });
            let inputData = {
                siteGuid: selectedSite.guid,
                tenantGuid: selectedSite.tenantGuid,
                logSiteName: selectedSite.siteName,
                tenantShortName: selectedTenant.shortName,
                siteName: this.state.siteName,
                siteDomain: this.state.siteDomain,
                customDomain1: this.state.customDomain1,
                customDomain2: this.state.customDomain2,
                crmUrl: this.state.crmUrl,
                crmDeliveryEmail: this.state.crmDeliveryEmail,
                crmDeliveryFormat: this.state.crmDeliveryFormat,
                defaultZipCode: this.state.defaultZipCode,
                offerExpirationDays: this.state.offerExpirationDays,
                status: this.state.status,
                valuationMethod: this.state.valuationMethod,
                useLocations: this.state.useLocations,
                isProduction: this.state.isProduction
            };
            this.props.applicationInsights.trackTrace({ message: "TenantSiteDetailComponent/onSaveClick", properties: { ...inputData, logon: this.props.logon } });
            return fetch("/TenantSite/SaveSiteDetail", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;"
                },
                body: JSON.stringify(inputData),
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    this.setState({
                        isLoadingData: false
                    }, () => {
                        this.props.onShowAlert("success", { message: "Changes saved successfully!" }, 4000);
                    });
                })
                .catch(notOKResponse => {
                    this.setState({ isLoadingData: false });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/TenantSite/SaveSiteDetail", ...inputData, ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "TenantSiteDetailComponent", "onSaveClick");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "TenantSiteDetailComponent", "onSaveClick");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "TenantSiteDetailComponent", "onSaveClick");
        }
    }

    render() {
        return <div className="d-flex flex-column admin-fill-content admin-body">
            <TenantSiteDetailQueryComponent
                tenants={this.state.tenants}
                canEdit={this.state.canEdit}
                onGetClick={this.onGetClick}
                isLoadingData={this.state.isLoadingData}
                isGlobalAdmin={this.props.isGlobalAdmin}
                onSaveClick={this.onSaveClick}
                onShowAlert={this.props.onShowAlert}
                applicationInsights={this.props.applicationInsights}
                logon={this.state.logon}
            />
            <br />
            <div className="admin-flex-item">
                <div className="d-flex flex-row">
                    <div className="card" style={{ "minWidth": "50%", "marginRight": "10px" }}>
                        <div className="card-header">
                            {this.state.cardTitle}&nbsp;
                        </div>
                        <div className="card-block">
                            <SellToWebAdminInputComponent id="siteName" label="Site Name" value={this.state.siteName} onChange={this.onTextChange} disabled colSpan="col-12" labelSpan="col-4" controlSpan="col-8" />
                            <SellToWebAdminInputComponent id="siteDomain" label="Site Domain" value={this.state.siteDomain} onChange={this.onTextChange} disabled={!this.state.canEdit} colSpan="col-12" labelSpan="col-4" controlSpan="col-8" />
                            <SellToWebAdminInputComponent id="customDomain1" label="Custom Domain 1" value={this.state.customDomain1} onChange={this.onTextChange} disabled={!this.state.canEdit} colSpan="col-12" labelSpan="col-4" controlSpan="col-8" />
                            <SellToWebAdminInputComponent id="customDomain2" label="Custom Domain 2" value={this.state.customDomain2} onChange={this.onTextChange} disabled={!this.state.canEdit} colSpan="col-12" labelSpan="col-4" controlSpan="col-8" />
                            <SellToWebAdminInputComponent id="crmUrl" label="CRM Url" value={this.state.crmUrl} onChange={this.onTextChange} disabled={!this.state.canEdit} colSpan="col-12" labelSpan="col-4" controlSpan="col-8" />
                            <SellToWebAdminInputComponent id="crmDeliveryEmail" label="CRM Delivery Email" value={this.state.crmDeliveryEmail} onChange={this.onTextChange} disabled={!this.state.canEdit} colSpan="col-12" labelSpan="col-4" controlSpan="col-8" tooltip='Separate emails using semi-colon, e.g., a@example.com; b@example.com' tooltipClassName="admin-tenant-site-detail-tips-tooltip" />
                            <SellToWebAdminInputComponent id="crmDeliveryFormat" label="CRM Delivery Format" value={this.state.crmDeliveryFormat} onChange={this.onTextChange} disabled={!this.state.canEdit} colSpancolSpan="col-12" labelSpan="col-4" controlSpan="col-8" />
                            <SellToWebAdminDropdownComponent id="valuationMethod" label="Valuation Method" data={this.valuationMethod} itemKey="value" onItemClick={this.onDropdownChange} value={this.state.valuationMethod ? this.state.valuationMethod : "Select Valuation Method"} disabled={!this.state.canEdit} colSpan="col-12" labelSpan="col-4" controlSpan="col-8" />
                            <SellToWebAdminInputComponent id="defaultZipCode" label="Default Zipcode" value={this.state.defaultZipCode} onChange={this.onTextChange} disabled={!this.state.canEdit} colSpan="col-12" labelSpan="col-4" controlSpan="col-8" tooltip="Zipcode used for valuation" tooltipClassName="admin-tenant-site-detail-tips-tooltip" />
                            <SellToWebAdminInputComponent id="offerExpirationDays" label="Days to offer expiration" value={this.state.offerExpirationDays} onChange={this.onTextChange} disabled={!this.state.canEdit} colSpan="col-12" labelSpan="col-4" controlSpan="col-8" />
                            <SellToWebAdminDropdownComponent id="status" label="Status" data={this.status} itemKey="value" onItemClick={this.onDropdownChange} value={this.state.status ? this.state.status : "Select Status"} disabled={!this.state.canEdit} colSpan="col-12" labelSpan="col-4" controlSpan="col-8" />
                            <SellToWebAdminInputComponent disabled label="Tenant Image Folder" value={"https://cdn.acquirecars.com/acquirecars/" + this.state.tenantGuid + "/image"} colSpan="col-12" labelSpan="col-4" controlSpan="col-8" />
                            <SellToWebAdminCheckboxComponent id="useLocations" label="Use Locations" value={this.state.useLocations} controlClassName="align-middle" onChange={this.onCheckboxChange} disabled={!this.state.canEdit} colSpan="col-12" labelSpan="col-4" controlSpan="col-8" />
                            {
                                this.props.isGlobalAdmin
                                    ? <Fragment>
                                        <SellToWebAdminCheckboxComponent id="useAutoCheck" label="Use AutoCheck" value={this.state.useAutoCheck} controlClassName="align-middle" onChange={this.onCheckboxChange} disabled colSpan="col-12" labelSpan="col-4" controlSpan="col-8" />
                                        <SellToWebAdminCheckboxComponent id="usePlateToVin" label="Use Plate to Vin" value={this.state.usePlateToVin} controlClassName="align-middle" onChange={this.onCheckboxChange} disabled colSpan="col-12" labelSpan="col-4" controlSpan="col-8" />
                                    </Fragment>
                                    : null
                            }
                            <SellToWebAdminCheckboxComponent id="isProduction" label="Is Production" value={this.state.isProduction} controlClassName="align-middle" onChange={this.onCheckboxChange} disabled={!this.state.canEdit} colSpan="col-12" labelSpan="col-4" controlSpan="col-8" />
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}